import { CloudFormationStackCopyDetails } from "@/components/runners/details/CloudFormationStackCopyDetails";
import { CloudFormationStackCreateButton } from "@/components/runners/details/CloudFormationStackCreateButton";
import { RunnerCreatedAt } from "@/components/runners/RunnerCreatedAt";
import { RunnerCreatedBy } from "@/components/runners/RunnerCreatedBy";
import { RunnerName } from "@/components/runners/RunnerName";
import { RunnerPhaseTag } from "@/components/runners/RunnerPhaseTag";
import type { PlainRunner } from "@/queries/runner-queries";
import { RunnerPhase } from "gitpod-next-api/gitpod/v1/runner_pb";
import { useState, type FC } from "react";
import { RunnerProviderLabel } from "@/components/runners/RunnerProvider";

export const RunnerInfoCard: FC<{ runner: PlainRunner; showInstallButton: boolean }> = ({
    runner,
    showInstallButton,
}) => {
    const [clicked, setClicked] = useState(false);

    return (
        <div className="flex flex-col gap-4 rounded-xl border-[0.5px] border-border-base bg-surface-glass px-5 py-4">
            <div className="flex flex-col">
                <RunnerName name={runner.name} />
                <RunnerProviderLabel provider={runner.provider} />
            </div>

            <div className="w-fit">
                <RunnerPhaseTag
                    runner={runner}
                    labelOverrides={{
                        [RunnerPhase.CREATED]: clicked ? "Waiting to connect" : "Ready to install",
                    }}
                />
            </div>

            <div className="flex flex-col">
                <RunnerCreatedAt runner={runner} />
                <RunnerCreatedBy runner={runner} />
            </div>

            {showInstallButton && runner.status?.phase != RunnerPhase.ACTIVE && (
                <div className="flex w-fit flex-col gap-2">
                    <div className="w-fit">
                        <CloudFormationStackCreateButton
                            text="Install with AWS CloudFormation"
                            runner={runner}
                            onClicked={() => setClicked(true)}
                        />
                    </div>
                    <CloudFormationStackCopyDetails runner={runner} />
                </div>
            )}
        </div>
    );
};
